import axios from 'axios';
import envProperties from '../../config/envProperties';

const apiUrl = process.env.REACT_APP_API_URL;

const logOutDetails = async () => {
  try {
    // CRITICAL: Distinguish between MSIL ADMIN portal and MASS portal
    // MSIL ADMIN: Has msil_id_token in localStorage AND email in sessionStorage
    // MASS: Has token and uid in sessionStorage (original behavior)
    
    const msilToken = localStorage.getItem('msil_id_token');
    const email = sessionStorage.getItem('email');
    const massToken = sessionStorage.getItem('token');
    const uid = sessionStorage.getItem('uid');
    
    // Determine if this is MSIL ADMIN user or MASS user
    const isMsilAdmin = msilToken && email; // MSIL admin has both msil_id_token and email
    
    if (isMsilAdmin) {
      // CRITICAL SECURITY FIX: MSIL ADMIN PORTAL - Call backend endpoint instead of external API directly
      // The apiKey is now stored securely in backend and never exposed to frontend
      console.log(`[Logout] MSIL Admin user detected. Calling backend logout-federation endpoint.`);
      
      const msilConfig = envProperties?.msil || {};
      const redirectUrl = msilConfig.redirectUrl?.replace('/AdminHome/dashboard', '/login') || 
        "https://massbusinesszone.com/login";
      
      console.log(`[Logout] Redirect URL: ${redirectUrl}`);
      
      // CRITICAL SECURITY FIX: Call backend endpoint instead of external API
      // Backend securely handles apiKey and clientId from configuration
      // Frontend only sends redirectUrl - no sensitive data exposed
      const backendLogoutUrl = `${apiUrl}/api/auth/logout-federation`;
      const requestBody = {
        redirectUrl: redirectUrl
      };
      
      // Get authentication token for backend call
      const token = localStorage.getItem('msil_id_token') || sessionStorage.getItem('token');
      
      const response = await axios.post(backendLogoutUrl, requestBody, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": token ? `Bearer ${token}` : undefined
        },
        timeout: 300000 // 5 minutes timeout
      });
      
      console.log(`[Logout] Backend logout-federation response - Status: ${response.status}, Data:`, response.data);
      
      // Return success - frontend will handle cleanup and redirect
      return { success: true, status: response.status, data: response.data, isMsilAdmin: true };
      
    } else {
      // MASS PORTAL: Use backend logout endpoint (ORIGINAL BEHAVIOR - DO NOT CHANGE)
      const username = uid;
      const token = massToken;
      console.log(`[Logout] MASS user detected. Using uid: ${username}`);
      
      if (!username) {
        console.warn("No username (uid) found for MASS logout");
        return null;
      }
      
      if (!token) {
        console.warn("No token found for MASS logout");
        return null;
      }
      
      const API_URL = `${apiUrl}/api/v1/authentication/logout?username=${encodeURIComponent(username)}`;

      const response = await axios.post(API_URL, null, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      console.log(`[Logout] MASS Logout API response:`, response.status);
      return response;
    }
  } catch (error) {
    console.error("Logout request failed:", error.message);
    // For MSIL Admin, if federation logout fails, still return success to allow cleanup
    // The frontend will handle cleanup regardless
    if (error.config?.url?.includes('logout-with-federation')) {
      console.warn("[Logout] ADFS Federation Logout API call failed, but continuing with cleanup");
      return { success: false, error: error.message };
    }
    // Don't throw the error — just handle it gracefully
    return null;
  }
};

export default { logOutDetails };
